// Toggle a scrolled state on the body so the homepage header switches
// from transparent (over hero) to a solid beige bar.
(function () {
  var threshold = 40;
  function onScroll() {
    document.body.classList.toggle('pm-scrolled', window.scrollY > threshold);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
